// This is duplicated on BE for email sending. Don't forget to update on both places!
const BOOKING_TRANSLATIONS: Record<string, { cs: string; en: string }> = {
    ['_contactPersonHeadline']: { cs: 'Kontaktní osoba', en: 'Contact person' },
    ['_name']: { cs: 'Jméno', en: 'Name' },
    ['_email']: { cs: 'Email', en: 'E-mail' },
    ['_phone']: { cs: 'Telefon', en: 'Phone' },
    ['_billingAddressHeadline']: { cs: 'Fakturační adresa', en: 'Billing address' },
    ['_companyName']: { cs: 'Název společnosti', en: 'Company name' },
    ['_streetAndHouseNumber']: { cs: 'Ulice a č.p.', en: 'Street and house number' },
    ['_city']: { cs: 'Město', en: 'City' },
    ['_zip']: { cs: 'PSČ', en: 'ZIP' },
    ['_company_id']: { cs: 'IČO', en: 'Company Identification Number (IČO)' },
    ['_vat']: { cs: 'DIČ', en: 'VAT ID (DIČ)' },
    ['_additionalOptionsHeadline']: { cs: 'Další možnosti', en: 'Additional options' },
    ['_additionalPeopleOnIndoorStand']: {
        cs: 'Dalších 3-5 lidí na vnitřním stánku (zpoplatněno +5000 CZK)',
        en: 'Additional 3-5 people on the indoor stand (charged +5000 CZK)'
    },
    ['_video_loop']: {
        cs: 'Prezentace společnosti ve videosmyčce v prostorách FEKT v den konání veletrhu PerFEKT JobFair',
        en: 'Presentation of the company in the video loop in the FEKT premises on the day of the PerFEKT JobFair'
    },
    ['_outdoorPowerSupply']: {
        cs: 'Venkovní přípojka 230V/400V',
        en: 'Outdoor power supply 230V/400V'
    }
};

export const getBookingStringTranslation = (key: string, language: string): string => {
    return BOOKING_TRANSLATIONS[key]?.[language] ?? BOOKING_TRANSLATIONS[key]?.['en'] ?? key;
};
